import {
  ICameraInfo,
  MODEL_KEY,
  FW_VERSION,
  BATTERY_CLOUD_SUPPORTED,
} from '@thingsw/pitta-modules';

export const getAbleBatteryCloud = (camera?: ICameraInfo) => {
  if (!camera) {
    return false;
  }

  if (
    (camera?.battery?.ssid?.startsWith('B124') &&
      !camera?.battery?.ssid?.startsWith('B124X')) ||
    camera?.battery?.ssid?.startsWith('B112')
  ) {
    return false;
  }

  const cameraModel = camera.model as MODEL_KEY;
  const cameraVersion = parseFloat(camera.fw_ver) as FW_VERSION;

  if (BATTERY_CLOUD_SUPPORTED.hasOwnProperty(cameraModel)) {
    const supportedVersion = BATTERY_CLOUD_SUPPORTED[cameraModel];

    if (supportedVersion && cameraVersion >= supportedVersion) {
      return true;
    }
  }

  return false;
};
